import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/Index.vue'
import Renjiadao from './components/Index/Renjiadao.vue'
import Video from './components/Index/Video.vue'
import UserAddNew from './components/Index/UserAddNew.vue'

import News from './views/News.vue'

// 后台页面懒加载（不进首屏 chunk）
const AdminNews = () => import(/* webpackChunkName: "admin" */ './views/AdminNews.vue')
const NewsBackEnd = () => import(/* webpackChunkName: "admin" */ './views/NewsBackEnd.vue')
const insertnews = () => import(/* webpackChunkName: "admin" */ './components/NewsBackEnd/CreateNews.vue')
const listnews = () => import(/* webpackChunkName: "admin" */ './components/NewsBackEnd/ListNews.vue')
const uploadnews = () => import(/* webpackChunkName: "admin" */ './components/NewsBackEnd/UploadNews.vue')
const listvideo = () => import(/* webpackChunkName: "admin" */ './components/NewsBackEnd/ListVideo.vue') 

Vue.use(Router)



const router = new Router({
    routes: [
        { name: 'index',  path: '/',  component: Index },
        { name: 'renjiadao', path: '/renjiadao', component: Renjiadao },
        { name: 'video', path: '/video', component: Video },
        { name: 'useraddnew', path: '/useraddnew', component: UserAddNew },

        { name: 'news', path: '/news/:id', component: News },
        { name: 'adminnews', path: '/admin', component: AdminNews },
        { 
            name: 'newsbackend', 
            path: '/news', 
            component: NewsBackEnd,
            children:[
                { name: 'insertnews', path: '/insertnews', component: insertnews, meta: { auth: true } },
                { name: 'uploadnews', path: '/uploadnews/:id', component: uploadnews, meta: { auth: true } },
                { name: 'listnews', path: '/listnews/:type/:page', component: listnews, meta: { auth: true } },
                { name: 'listvideo', path: '/listvideo/:page', component: listvideo, meta: { auth: true } },
            ],
            meta: {
                auth: true
            }
        },
    ],
    // mode: 'history',
    // base: '/CALAWA/',
})

export default router

/* eslint-disable */

// // 路由判断登录 根据路由配置文件的参数
router.beforeEach((to, from, next) => {
    //如果路由meta中存在auth,进行拦截
    if (to.meta.auth){ 
        // console.log('需要登录');
        // console.log(sessionStorage.getItem('loginin'));
        // console.log(sessionStorage.getItem('loginin') == undefined);
        // console.log(sessionStorage.getItem('loginin'));
        // console.log(sessionStorage.getItem('loginin') !== null);
        // console.log(sessionStorage.getItem('loginin') !== null || sessionStorage.getItem('loginin') !== '' || sessionStorage.getItem('loginin') !== undefined);
        if(sessionStorage.getItem('loginin') !== null ){
            if(sessionStorage.getItem('loginin') !== ''){
                if(sessionStorage.getItem('loginin') !== undefined){
                    next();
                } else{
                    // sessionStorage.setItem('loginin','');
                    next({
                        path: '/admin',
                        query: {redirect:to.fullPath}
                    })
                }
            } else{
                // sessionStorage.setItem('loginin','');
                next({
                    path: '/admin',
                    query: {redirect:to.fullPath}
                })
            }
        } else{
            // sessionStorage.setItem('loginin','');
            next({
                path: '/admin',
                query: {redirect:to.fullPath}
            })
        }
    } else{
        next()
    }
})